<template>
  <main
    key="auth-layout"
    class="flex flex-col items-center bg-gray-light h-dvh"
  >
    <header class="mt-16 mb-6">
      <Icon
        class="logo"
        :data="appLogo"
        alt="support sync pro logo"
        original
        height="40"
        width="auto"
      />
    </header>
    <slot></slot>
  </main>
</template>

<script setup lang="ts">
import { appLogo } from "~/composables/app";
</script>

<style scoped lang="scss">
main {
  :deep(section) {
    background-color: var(--app-white);
    padding: 56px;
    border-radius: 32px;
    box-shadow: 0px 0px 44px 2px var(--app-gray-402-alpha-3-137255);
  }
  :deep(> *) {
    flex-basis: auto;
  }
}
</style>
